import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["suggestion pointer", {selected: $props.selected}])
  }, [
    _createVNode(_component_Ellipsis, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($options.name), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    ($props.checkIcon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "check",
          icon: "check",
          size: "1.6rem",
          stroke: "var(--brand-500)"
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}